import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslationService } from '@sdbn/common';
import { Column, ColumnDefinitions, ColumnEditorMode } from '../column-definitions';



@Component({
    selector: 'app-table-column-editor',
    templateUrl: './table-column-editor.component.html',
    styleUrls: ['./table-column-editor.component.scss'],
    standalone: false
})
export class TableColumnEditorComponent {


  editMode = false;

  columnsByKey = new Map<string, Column>();

  mode: ColumnEditorMode;
  _columns: string;

  configuredColumns = new Array<string>();
  availableColumns = new Array<string>();

  @Input() set setMode(mode: ColumnEditorMode) {
    this.mode = mode;
    this.initEditor();
  }

  @Input() set columns(columns: string) {
    this._columns = columns || '';
    this.initEditor();
  }

  @Output() columnsChanged = new EventEmitter<string>();

  constructor(public translationService: TranslationService) {



  }

  private initEditor() {
    if (this.mode != null && this._columns != null) {

      this.configuredColumns = new Array<string>();

      const columns = this.mode === ColumnEditorMode.TRANSPORT ? ColumnDefinitions.transportColumns : ColumnDefinitions.visitorColumns;

      for (const col of columns) {
        this.columnsByKey.set(col.key, col);
      }

      this.availableColumns = columns.map(tc => tc.key);
      this.initializeEditableColumns();
      this.sortAvailableColumns();
    }
  }

  private initializeEditableColumns() {
    for (const c of this._columns.split('|')) {
      if (this.columnsByKey.get(c) != null) {
        this.configuredColumns.push(c);
        const index = this.availableColumns.indexOf(c);
        if (index !== -1) {
          this.availableColumns.splice(index, 1);
        }
      } else {
        console.log('invalid column definition [' + c + ']');
      }
    }
  }

  public drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }

    this.handleColumnsChanged();
  }

  public dropToAvailableList(event: CdkDragDrop<string[]>) {
    if (event.previousContainer !== event.container) {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }

    this.sortAvailableColumns();
    this.handleColumnsChanged();
  }

  public startEditing() {
    this.editMode = true;
  }

  public endEditing() {
    this.editMode = false;
  }

  private sortAvailableColumns() {
    // Sort available columns by translation
    this.availableColumns.sort((a, b) => {
      let ta = this.translationService.translate(
        this.columnsByKey.get(a) == null ?
          'shared.transport-column-editor.invalid-column' : this.columnsByKey.get(a).dictionaryKey
      );
      if (ta == null) {
        ta = a;
      }
      ta = ta.toLowerCase();

      let tb = this.translationService.translate(
        this.columnsByKey.get(b) == null ?
          'shared.transport-column-editor.invalid-column' : this.columnsByKey.get(b).dictionaryKey
      );
      if (tb == null) {
        tb = b;
      }
      tb = tb.toLowerCase();

      return ta > tb ? 1 : ta === tb ? 0 : -1;
    });
  }

  private handleColumnsChanged() {
    this._columns = this.configuredColumns.join('|');
    this.columnsChanged.next(this._columns);
  }
}
